import { createSelector } from 'reselect';
import { getAppConfig } from '../selectors/basketSelectors';

const getCookieConsent = (state: WebOrder.State) => state.cookieConsent;

export const hasGdprCookieFeatureFlag = createSelector<
  WebOrder.State,
  ReturnType<typeof getAppConfig>,
  boolean
>([getAppConfig], (config) => {
  return config ? config.Features.includes('enable-gdpr-cookies') : false;
});

export const hasDisableNonEssentialCookies = createSelector<
  WebOrder.State,
  ReturnType<typeof getAppConfig>,
  boolean
>([getAppConfig], (config) => {
  return config ? config.Features.includes('disable-non-essential-cookies') : false;
});

const getCookieConsentGroups = createSelector<
  WebOrder.State,
  ReturnType<typeof getCookieConsent>,
  WebOrder.State.CookieConsent['selectedGroups']
>([getCookieConsent], (cookieConsent) => {
  return cookieConsent.selectedGroups;
});

export const isFunctionalCookieConsentEnabled = createSelector<
  WebOrder.State,
  ReturnType<typeof getCookieConsentGroups>,
  boolean
>([getCookieConsentGroups], (groups) => {
  const isFunctionalEnabled = groups.includes('functional');
  return isFunctionalEnabled;
});

export const enableRememberMe = createSelector<WebOrder.State, any, boolean>(
  [
    getAppConfig,
    hasGdprCookieFeatureFlag,
    isFunctionalCookieConsentEnabled,
    getCookieConsentGroups
  ],
  (
    config: ReturnType<typeof getAppConfig>,
    hasFeatureFlag: ReturnType<typeof hasGdprCookieFeatureFlag>,
    isFunctionalEnabled: ReturnType<typeof isFunctionalCookieConsentEnabled>,
    consentGroups: ReturnType<typeof getCookieConsentGroups>
  ) => {
    const enableRememberMe =
      consentGroups.length !== 0 && !isFunctionalEnabled && hasFeatureFlag && !!config;
    return enableRememberMe;
  }
);
